import React from 'react';

import { Fabric } from 'office-ui-fabric-react/lib/Fabric';
import {
  DetailsList,
  DetailsListLayoutMode,
  SelectionMode
} from 'office-ui-fabric-react/lib/DetailsList';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { ProgressIndicator } from 'office-ui-fabric-react/lib/ProgressIndicator';
import { Icon } from 'office-ui-fabric-react/lib/Icon';

import XHRUploader from 'react-xhr-uploader';
import Cookies from "universal-cookie";

import HttpService from '../service/HttpService';
import Header from '../component/Header';

export default class Sinesters extends React.Component {
  http = new HttpService();
  loader = null;
  lo = require( 'lodash' );
  toPost = {};
  
  constructor( props ) {
    super( props );

    let cookies = new Cookies();
    let session = cookies.get( 'session' );

    if( !session ) {
      window.location.href = '/auth';
    }

    this.state = {
      viewOpen: false,
      showPanel: false,
      presentationPanel: false,
      activeItem: {},
      items: [],
      clients: [],
      showDocuments: false,
      documents: []
    };
  }

  componentDidMount() {
    let loader = this.refs.header.loader().loading( 'Cargando siniestros...' );
    
    this.http
      .getSinesters()
      .then( sinesters => {
        this.setState({ items: sinesters }, () => {
          if( this.props.match.params.id !== undefined ) {
            this.filter( this.props.match.params.id );
          }
        });
      
        loader.loading( 'Cargando clientes...' );

        this.http
          .getClients()
          .then( clients => {
            this.setState({ clients: clients });

            loader.loading( 'Cargando pólizas...' );

            this.http
              .getPolicies()
              .then( policies => {
                this.setState({ policies: policies });

                loader.finish();
              })
              .catch( this.errorHandler );
          })
          .catch( this.errorHandler );
      })
      .catch( this.errorHandler );
  }

  errorHandler = ( error ) => {
    this.refs.header.loader().finish();

    this.refs.header.dialog().show( error );
  }

  selectedItemChange = ( item ) => {
    this.setState({
      viewOpen: item
    });
  }

  export = () => {
    console.log( this.state.items );
    
    let exportData = [ 
      '#', 'Nombre', 'Teléfono', 'Email', 'DNI / CUIT', 
      'Compañia', 'Tipo', 'Número de póliza', 'Inicio cobertura', 'Fin cobertura', 'Referencia',
      'Fecha siniestro', 'Descripción', 'Ubicación', 'Conductor', 'Tercero involucrado', 'Teléfono', 'Aseguradora', 'Vehículo', 'Modelo', 'Patente'
     ].join( ',' ) + '\r\n';

    this.state.items.forEach( ( item, index ) => {
      let start = item.policy.coverage_start.date.split( ' ' );
      let end = item.policy.coverage_end.date.split( ' ' );
      let row = [ 
        item.client.id, item.client.name, item.client.phone, item.client.email, item.client.documentNumber, 
        item.policy.company.name, item.policy.type.name, item.policy.policy_number, start[0], end[0], item.policy.reference,
        item.datetime, item.description, item.street, item.driverName + ' ' + item.driverSurname, item.partyName + ' ' + item.partySurname, item.partyPhone, item.partyCompany, item.partyCar, item.partyCarModel, item.partyCarPatent
      ];

      exportData = exportData + row.join( ',' ) + '\r\n';
    });

    var hiddenElement = document.createElement('a');
    hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI( exportData );
    hiddenElement.target = '_blank';
    hiddenElement.download = 'report.csv';
    hiddenElement.click();
  }

  editItemHandler = () => {
    if( this.state.viewOpen !== false ) {
      if( this.state.viewOpen.reportNumber ) {
        this.errorHandler( 'El siniestro ya fue presentado en la compañia aseguradora. Se le asignó el número de siniestro ' + this.state.viewOpen.reportNumber );
      } else {
        this.setState({
          showPanel: true,
          activeItem: this.state.viewOpen
        })
  
        this.toPost = this.lo.cloneDeep( this.state.viewOpen );
      }
    } else {
      this.setState({ activeItem: {} });

      this.errorHandler( 'Debe seleccionar un siniestro para editar' );
    }
  }

  deleteItemHandler = () => {
    if( this.state.viewOpen !== false ) {

      let loader = this.refs.header.loader().loading( 'Guardando cambios...' );
      
      this.http
        .deleteSinester( this.state.viewOpen.id )
        .then( ( sinesters ) => {
          this.toPost = null;

          this.setState({ items: sinesters, activeItem: {}, viewOpen: false }, () => {
            if( this.props.match.params.id !== undefined ) {
              this.filter( this.props.match.params.id );
            }
          });

          loader.finish();
        })
    } else {
      this.errorHandler( 'Debe seleccionar un siniestro para eliminar' );
    }
  }

  presentationHandler = () => {
    if( this.state.viewOpen !== false ) {
      if( this.state.viewOpen.reportNumber ) {
        this.errorHandler( 'El siniestro ya fue presentado en la compañia aseguradora. Se le asignó el número de siniestro ' + this.state.viewOpen.reportNumber );
      } else {
        this.toPost = this.lo.cloneDeep( this.state.viewOpen );
        this.setState({ presentationPanel: true });
      }
    } else {
      this.errorHandler( 'Debe seleccionar un siniestro para realizar la presentación' );
    }
  }

  saveItemHandler = () => {
    let loader = this.refs.header.loader().loading( 'Guardando cambios...' );

    this.http
      .saveSinester( this.toPost )
      .then( ( sinesters ) => {
        this.toPost = null;

        this.setState({ items: sinesters, activeItem: {}, viewOpen: false }, () => {
          if( this.props.match.params.id !== undefined ) {
            this.filter( this.props.match.params.id );
          }
        });

        loader.finish();
      })
      .catch( this.errorHandler );

    this.setState({ showPanel: false, presentationPanel: false });
  }

  updateItem = ( item, name = null ) => {
    if( name !== null) {
      this.toPost[name] = item;
    } else {
      this.toPost[item.target.name] = item.target.value;
    }
  }

  filter = ( id ) => {
    var _filtered = [];

    for( var i=0; i<this.state.items.length; i++ ) {
      console.log( this.state.items[i].client.id, id);
      if( this.state.items[i].client.id == id ) {
        _filtered.push( this.state.items[i] );
      }
    }

    this.setState({ items: _filtered });
  }
  
  render() {
    const items = this.state.items;
    const columns = [
      {
        key: 'column2',
        name: 'Fecha del siniestro',
        fieldName: 'datetime',
        minWidth: 120,
        maxWidth: 150,
        isRowHeader: true,
        isResizable: true,
        isSorted: true,
        isSortedDescending: false,
        data: 'string',
        isPadded: true
      },
      {
        key: 'column3',
        name: 'Cliente',
        fieldName: 'client_name',
        minWidth: 200,
        maxWidth: 350,
        isResizable: true,
        data: 'string',
        isPadded: true
      },
      {
        key: 'column4',
        name: 'Aseguradora',
        fieldName: 'company_name',
        minWidth: 80,
        maxWidth: 200,
        isResizable: true,
        isCollapsable: true,
        data: 'string',
        isPadded: true
      },
      {
        key: 'column5',
        name: 'Tipo Póliza',
        fieldName: 'type_name',
        minWidth: 150,
        maxWidth: 300,
        isResizable: true,
        isCollapsable: true,
        data: 'string',
        isPadded: true 
      },
      {
        key: 'column5',
        name: 'Compañia Tercero',
        fieldName: 'partyCompany',
        minWidth: 150,
        maxWidth: 300,
        isResizable: true,
        isCollapsable: true,
        data: 'string',
        isPadded: true 
      },
      {
        key: 'column5',
        name: 'Número siniestro',
        fieldName: 'reportNumber',
        minWidth: 150,
        maxWidth: 300,
        isResizable: true,
        isCollapsable: true,
        data: 'string',
        isPadded: true 
      }
    ]

    const menuItems = [
      {
        key: 'new',
        text: 'Nuevo',
        iconProps: {
          iconName: 'Add'
        },
        onClick: () => document.location.href = '/sinester-new' 
      },
      {
        key: 'edit',
        text: 'Editar',
        iconProps: {
          iconName: 'Edit'
        },
        onClick: this.editItemHandler
      },
      {
        key: 'delete',
        text: 'Eliminar',
        iconProps: {
          iconName: 'Delete'
        },
        onClick: this.deleteItemHandler
      },
      {
        key: 'present',
        text: 'Presentar',
        iconProps: {
          iconName: 'CheckMark'
        },
        onClick: this.presentationHandler
      }
    ];
    const menuFarItems = [
      {
        key: 'info',
        iconOnly: true,
        iconProps: {
          iconName: 'Info'
        }
      },
      {
        key: 'reload',
        text: 'Recargar',
        iconOnly: true,
        iconProps: {
          iconName: 'Refresh'
        },
        onClick: () => document.location.href = '/sinesters' 
      }
    ];
    const customItems = [{
        key: 'export',
        text: 'Exportar',
        iconProps: {
          iconName: 'ExcelLogo'
        },
        onClick: this.export
    }];

    return (
      <Fabric>
        <Header title="Siniestros" ref="header" />

        <div className="ms-Grid">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-lg12" style={{ margin: 0, padding: 0 }}>
              <CommandBar
                  items={ menuItems }
                  overflowItems={ customItems }
                  farItems={ menuFarItems }
                />
            </div>
          </div>
          <div className="ms-Grid-row">
            <div className={ "ms-Grid-col ms-sm12 " + ( this.state.viewOpen ? 'ms-lg9' : 'ms-lg12' ) } style={{ borderRight: '1px solid #ccc', paddingTop: 20 }}> 
              <DetailsList
                items={ items }
                columns={ columns }
                selectionMode={ SelectionMode.none }
                setKey="id"
                layoutMode={ DetailsListLayoutMode.justified } 
                onActiveItemChanged={ this.selectedItemChange } />
            </div>
            <div className="ms-Grid-col ms-sm12 ms-lg3 ms-font-m" style={{ paddingTop: 20, display: this.state.viewOpen ? 'block' : 'none' }}>
              <div style={{ textAlign: 'right' }}><Icon iconName="ChromeClose" style={{ cursor: 'pointer' }} onClick={ () => { this.setState( { viewOpen: false, activeItem: {} } ); } }/></div>
              <h3 className="ms-font-xl">{ this.state.viewOpen.reportNumber ? this.state.viewOpen.reportNumber : 'Sin presentar' } ({ this.state.viewOpen.company_name })</h3>
              <hr />
              <p>
              <strong className="ms-fontWeight-semibold">Compañia</strong>: { this.state.viewOpen.company_name }<br/>
                <strong className="ms-fontWeight-semibold">Tipo</strong>: { this.state.viewOpen.type_name }<br/>
                <strong className="ms-fontWeight-semibold">Póliza</strong>: { this.state.viewOpen.policy ? this.state.viewOpen.policy.policy_number : '' }
              </p>
              <h3>Cliente</h3>
              <p>
                { this.state.viewOpen.client ? this.state.viewOpen.client.name : '' }<br/>
                { this.state.viewOpen.client ? this.state.viewOpen.client.documentNumber : '' }<br/>
                <em>Teléfono</em> { this.state.viewOpen.client ? this.state.viewOpen.client.phone : '' }<br/>
                <em>Email</em> { this.state.viewOpen.client ? this.state.viewOpen.client.email : '' }<br/>
              </p>
              <h3>Datos del siniestro</h3>
              <p>
                <strong className="ms-fontWeight-semibold">Fecha</strong>: { this.state.viewOpen.datetime }<br/>
              </p>
              <p><strong className="ms-fontWeight-semibold">Descripción</strong>:<br/> { this.state.viewOpen.description }</p>
              <p>
                <strong className="ms-fontWeight-semibold">Ubicación</strong>: { this.state.viewOpen.street }<br/>
                <strong className="ms-fontWeight-semibold">Conductor</strong>: { this.state.viewOpen.driverName } { this.state.viewOpen.driverSurname } ({ this.state.viewOpen.driverLicence})<br/>
                <strong className="ms-fontWeight-semibold">Tercero Involucrado</strong>: { this.state.viewOpen.partyName } { this.state.viewOpen.partySurname }<br/>
                <strong className="ms-fontWeight-semibold">Teléfono</strong>: { this.state.viewOpen.partyPhone }<br/>
                <strong className="ms-fontWeight-semibold">Aseguradora</strong>: { this.state.viewOpen.partyCompany }<br/>
              </p>
              <p>
                <strong className="ms-fontWeight-semibold">Vehículo</strong>: { this.state.viewOpen.partyCar }<br/>
                <strong className="ms-fontWeight-semibold">Modelo</strong>: { this.state.viewOpen.partyCarModel }<br/>
                <strong className="ms-fontWeight-semibold">Patente</strong>: { this.state.viewOpen.partyCarPatent }
              </p>
            </div>
          </div>
          <Panel
            isOpen={this.state.presentationPanel}
            type={PanelType.smallFluid}
            onDismiss={ () => this.setState({ presentationPanel: false }) }
            headerText="Presentación del siniestro"
            onRenderFooter={ () => {
              return (
                <div className="ms-textAlignCenter">
                  <PrimaryButton onClick={ this.saveItemHandler } style={{ marginRight: 10 }}>Guardar</PrimaryButton>
                  <DefaultButton onClick={ () => this.setState({ presentationPanel: false }) } >Cancelar</DefaultButton>
                </div>

              )
            }}>
              <div className="ms-Grid">
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12 ms-lg3"></div>
                  <div className="ms-Grid-col ms-sm12 ms-lg6">
                    <TextField label="Número de siniestro asignado por la aseguradora" onChange={ ( item ) => { this.updateItem( item, null )} } name="reportNumber"/>
                    <p style={{ marginTop: 20 }}>Adjuntar documentación</p>
                    <XHRUploader url={ "https://gosalbezehijos.com/entrypoint/sinester/attachment/" + this.state.viewOpen.id } dropzoneLabel='Arrastre o seleccione el archivo que se desea adjuntar' auto />
                    <p className="ms-font-xs">Una vez guardado esta documentación será enviada a { this.state.viewOpen.client ? this.state.viewOpen.client.name : '' } a la dirección de mail  { this.state.viewOpen.client ? this.state.viewOpen.client.email : '' }</p>
                  </div>
                </div>
              </div>
          </Panel>
          <Panel
            isOpen={this.state.showPanel}
            type={PanelType.smallFluid}
            onDismiss={ () => this.setState({ showPanel: false }) }
            headerText="Siniestro"
            onRenderFooter={ () => {
              return (
                <div className="ms-textAlignCenter">
                  <PrimaryButton onClick={ this.saveItemHandler } style={{ marginRight: 10 }}>Guardar</PrimaryButton>
                  <DefaultButton onClick={ () => this.setState({ showPanel: false }) } >Cancelar</DefaultButton>
                </div>

              )
            }}>
              <div className="ms-Grid">
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12 ms-lg12">
                    <TextField name="datetime" label="Fecha del siniestro" value={ this.state.activeItem.datetime } onChange={ ( item ) => { this.updateItem( item, null )} }/>
                  </div>
                </div>
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12 ms-lg12">
                    <TextField name="description" multiline rows={5} label="Descripción" value={ this.state.activeItem.description } onChange={ ( item ) => { this.updateItem( item, null )} }/>
                  </div>
                </div>
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12 ms-lg12">
                    <TextField name="street" label="Calle o intersección" value={ this.state.activeItem.street } onChange={ ( item ) => { this.updateItem( item, null )} }/>
                  </div>
                </div>
                <div className="ms-Grid-row" style={{ marginTop: 20 }}><div className="ms-Grid-col ms-sm12 ms-lg12"><h3>Datos del conductor</h3></div></div>
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12 ms-lg4">
                    <TextField name="driverName" label="Nombre" value={ this.state.activeItem.driverName } onChange={ ( item ) => { this.updateItem( item, null )} }/>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg4">
                    <TextField name="driverSurname" label="Apellido" value={ this.state.activeItem.driverSurname } onChange={ ( item ) => { this.updateItem( item, null )} }/>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg4">
                    <TextField name="driverLicence" label="Licencia" value={ this.state.activeItem.driverLicence } onChange={ ( item ) => { this.updateItem( item, null )} }/>
                  </div>
                </div>
                <div className="ms-Grid-row" style={{ marginTop: 20 }}><div className="ms-Grid-col ms-sm12 ms-lg12"><h3>Datos del tercero</h3></div></div>
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12 ms-lg4">
                    <TextField name="partyName" label="Nombre" value={ this.state.activeItem.partyName } onChange={ ( item ) => { this.updateItem( item, null )} }/>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg4">
                    <TextField name="partySurname" label="Apellido" value={ this.state.activeItem.partySurname } onChange={ ( item ) => { this.updateItem( item, null )} }/>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg4">
                    <TextField name="partyPhone" label="Teléfono" value={ this.state.activeItem.partyPhone } onChange={ ( item ) => { this.updateItem( item, null )} }/>
                  </div>
                </div>
                <div className="ms-Grid-row" style={{ marginTop: 20 }}><div className="ms-Grid-col ms-sm12 ms-lg12"><h3>Datos del vehículo</h3></div></div>
                <div className="ms-Grid-row" style={{ marginBottom: 40 }}>
                  <div className="ms-Grid-col ms-sm12 ms-lg4">
                    <TextField name="partyCar" label="Nombre" value={ this.state.activeItem.partyCar } onChange={ ( item ) => { this.updateItem( item, null )} }/>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg4">
                    <TextField name="partyCarModel" label="Apellido" value={ this.state.activeItem.partyCarModel } onChange={ ( item ) => { this.updateItem( item, null )} }/>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg4">
                    <TextField name="partyCarPatent" label="Patente" value={ this.state.activeItem.partyCarPatent } onChange={ ( item ) => { this.updateItem( item, null )} }/>
                  </div>
                </div>
              </div>
          </Panel>
          
        </div>
      </Fabric>
    );
  }
}


// WEBPACK FOOTER //
// ./src/screen/Sinesters.jsx